
import ShopCartData from "../components/views/shopcart/ShopCartData.js"
import OrderRowData from "../components/views/shopcart/OrderRowData.js"
import { eventBus } from "../eventbus";


export default {
    data: function() {
        return {
            shopCartData: null
        }
    },
    methods: {
        newCart: function(origin) { /* crea carrello vuoto */
            console.log('newCart');
            var vm = this;
            vm.shopCartData = new ShopCartData(vm); 
            var idC = vm.$root.token.idCliente;

            var pResolve,
                pReject;

            var promise = new Promise((function(resolve, reject){
                pResolve = resolve;
                pReject = reject;
            }))
            vm.$root.getClientDiscounts(idC).then((discounts)=>{
                if(discounts != null && discounts.length > 0) {
                    //inizialmente imposto lo sconto base relativo al tipo ordine Standard, poi lo sconto base cambia dinamicamente in base alla scelta nella tendina del tipo ordine
                    var std_dis = discounts.find((d) => d.type == 'Standard')
                    if(std_dis){
                        vm.shopCartData.scontoBase = std_dis.value
                    }/* else{
                        vm.shopCartData.scontoBase = 0
                    } */
                }else{
                    vm.shopCartData.tipoOrdine = 'Standard'
                    vm.shopCartData.scontoBase = 0; 
                }

                if(this.$Configs.ecp && this.$Configs.ecp.tipoIntegrazione && this.$Configs.ecp.tipoIntegrazione.includes("Invia prodotti nel carrello")){
                    //se è attiva un'interfaccia con tipo integrazione = invia prodotti nel carrello
                    //non faccio la ricerca indirizzi
                    vm.shopCartData.riferimento = vm.getTempReferenceId()
                    console.log('ecp - nuovo carrello creato', vm.shopCartData);
                    pResolve()
                }else{
                    vm.getClientAddress(origin).then((readyCart)=>{
                        if(readyCart){
                            vm.shopCartData.riferimento = vm.getTempReferenceId()
                            console.log('nuovo carrello creato', vm.shopCartData);
                            pResolve()
                        }else{
                            vm.shopCartData = null;
                            pResolve()
                        }
                    })
                }
            })
            return promise;

        },
        saveCart: function(cb) {  
            var vm = this,
                fnName = 'saveCart';
              
            if( vm.$root.dbRegistry == null) {
                console.log(fnName+" - dbRegistry not loaded!");
                return;
            }

            var reg_orders, reg_order_items;

            reg_orders = vm.$root.dbRegistry.getCollection('orders');
            reg_order_items = vm.$root.dbRegistry.getCollection('orderItems');

            if( reg_order_items == null) {
                console.log(fnName+' - reg_orders: catalogo inesistente!')
            }

            if( reg_orders != null && reg_order_items != null) {
                    
                var idU = vm.$root.token.idUtente ? Number(vm.$root.token.idUtente) : null;
                var idC = vm.$root.token.idCliente;

                let now = new Date();

                console.log('vm.shopCartData.id: ', vm.shopCartData.id)
                console.log('vm.shopCartData.rif: ', vm.shopCartData.riferimento)
                
                if ( vm.shopCartData.id == 0) {

                    var order = reg_orders.insert( {
                            id: vm.shopCartData.riferimento, 
                            oty: vm.shopCartData.tipoOrdine,
                            osi: vm.shopCartData.statoOrdine,
                            coi: idC,
                            cid: vm.shopCartData.valutaOrdine,
                            uid: idU,
                            lid: vm.shopCartData.language,
                            bdi: vm.shopCartData.scontoBase,
                            ord: vm.shopCartData.dataOrdine,
                            not: vm.shopCartData.note,
                            coc: vm.shopCartData.vostroRif,

                            add: vm.shopCartData.consegna.indirizzo, //? vm.shopCartData.consegna.indirizzo : vm.shopCartData.anagraficaCliente.indirizzo,
                            cap: vm.shopCartData.consegna.cap, //? vm.shopCartData.consegna.cap : vm.shopCartData.anagraficaCliente.cap,
                            loc: vm.shopCartData.consegna.localita, //? vm.shopCartData.consegna.localita : vm.shopCartData.anagraficaCliente.localita,
                            reg: vm.shopCartData.consegna.regione, //? vm.shopCartData.consegna.regione : vm.shopCartData.anagraficaCliente.regione,
                            pro: vm.shopCartData.consegna.provincia, //? vm.shopCartData.consegna.provincia : vm.shopCartData.anagraficaCliente.provincia,
                            nat: vm.shopCartData.consegna.nazione, //? vm.shopCartData.consegna.nazione : vm.shopCartData.anagraficaCliente.nazione,
                            tel: vm.shopCartData.consegna.telefono, //? vm.shopCartData.consegna.telefono : vm.shopCartData.anagraficaCliente.telefono,
                            fax: vm.shopCartData.consegna.fax, //? vm.shopCartData.consegna.fax : vm.shopCartData.anagraficaCliente.fax,
                            ufn: vm.shopCartData.consegna.nominativo, //destinatario indirizzo

                            dti: vm.shopCartData.spedizione.tipoSpedizione,
                            dbr: vm.shopCartData.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('yes') || vm.$root.shopCartData.spedizione.accorpaSpedizione == true ? true : false,
                            pti: vm.shopCartData.consegna.tipoPorto,
                            aid: vm.shopCartData.consegna.idIndirizzo,

                            mdt: now
                        } );
    
                    console.log(fnName+' - Inserito nuovo ordine con ID:', order.id);
                    
                    vm.shopCartData.id = order.id;
                    //imposto anche una nuova proprietà della struttura ShopCartData: 
                    //$loki è la proprietà che non varia prima e dopo la sync bi-dir
                    //userò $loki per recuperare il record dall'idb dopo la sync bi-dir
                    vm.shopCartData.$loki = order.$loki;

                    if( order != null) {
                        var idOrder = order.id;
                        var products = vm.shopCartData.prodotti;
                        if( products.length > 0 ) {
                            for(var idx = 0; idx <products.length; idx++){      
                                
                                var product = products[idx];  
                                
                                var orderRow = reg_order_items.insert( {
                                    id: reg_order_items.data.length > 0 ? '-' + reg_order_items.maxId + 1 : -1,
                                    oid : idOrder,
                                    pid: product.codiceProd, //pid è il nuovo
                                    spi: product.codSost, //spi è il vecchio             
                                    ide: product.descrizione,             
                                    uni: product.unitaMisura, 
                                    qty : product.quantita, 
                                    ulp: product.prezzoOriginario,  
                                    unp : product.prezzoUnitario, // prezzo già scontato in base al tipo ordine standard e all'eventuale profilo sconti
                                    sta: product.statoProdotto, 
                                    mdt: product.dataModifica, 
                                    udt : product.dataUltimaModifica,
                                    ldi: product.codlinea,
                                    mpi: product.codmacch,
                                    mde: product.desmacch,
                                    vdt: vm.$root.validity,
                                    cd1: product.scontoCliente,
                                    cd2: product.scontoArticolo,
                                    not: product.noteRiga,
                                    qas: product.statoDisponibilità
                                } );

                                for(var i=0;i<vm.shopCartData.prodotti.length; i++){
                                    if(vm.shopCartData.prodotti[i].codiceProd == orderRow.pid){
                                        vm.shopCartData.prodotti[i].id = orderRow.id
                                        vm.shopCartData.prodotti[i].oid = orderRow.oid
                                    }
                                }

                                if (orderRow != null) { 
                                    console.log(fnName+' - inserito prodotto: ', orderRow.id, ' per ordine: ', order.id);
                                }   
                            }
                        }
                    }else {
                        console.log("Carrello non creato");                                
                    }

                }else{
                    var order = reg_orders.find({'id': vm.shopCartData.id})[0],
                        now = Date.now(),
                        changed = false;
                    
                    if( order != null) {
                        //sono arrivato qui se devo aggiornare il record dell'ordine
                        //confronto campi effettivamente cambiati per evitare update inutili 
                        //potrei aver cambiato tipo ordine, indirizzo, porto, spedizione, data consegna, stato ordine, altrorichiedente o altroindirizzo, etc.
                        
                        var scd = vm.$root.shopCartData,
                            o_aid = scd.altroindirizzoconsegna.idIndirizzo ? scd.altroindirizzoconsegna.idIndirizzo : scd.consegna.idIndirizzo,
                            o_add = scd.altroindirizzoconsegna.indirizzo ? scd.altroindirizzoconsegna.indirizzo : scd.consegna.indirizzo,
                            o_loc = scd.altroindirizzoconsegna.localita ? scd.altroindirizzoconsegna.localita : scd.consegna.localita,
                            o_reg = scd.altroindirizzoconsegna.regione ? scd.altroindirizzoconsegna.regione : scd.consegna.regione,
                            o_pro = scd.altroindirizzoconsegna.provincia ? scd.altroindirizzoconsegna.provincia : scd.consegna.provincia,
                            o_nat = scd.altroindirizzoconsegna.nazione ? scd.altroindirizzoconsegna.nazione : scd.consegna.nazione,
                            o_ufn = scd.altrorichiedente.nomecognome ? scd.altrorichiedente.nomecognome : scd.consegna.nominativo,
                            o_dbr = scd.spedizione.accorpaSpedizione == vm.$Jed.firstUpperTranslate('yes') || scd.spedizione.accorpaSpedizione == true ? true : false,
                            o_drd = scd.consegna.consegnaRichiesta ? scd.consegna.consegnaRichiesta : null,
                            o_oty = scd.tipoOrdine ? vm.$root.shopCartData.tipoOrdine : 'Standard';

                        //possono cambiare nel 2° step del carrello
                        if(order.aid != o_aid){order.aid = o_aid; changed = true;}
                        if(order.add != o_add){order.add = o_add; changed = true;}
                        if(order.loc != o_loc){order.loc = o_loc; changed = true;}
                        if(order.reg != o_reg){order.reg = o_reg; changed = true;}
                        if(order.pro != o_pro){order.pro = o_pro; changed = true;}
                        if(order.nat != o_nat){order.nat = o_nat; changed = true;}
                        if(order.ufn != o_ufn){order.ufn = o_ufn; changed = true;}
                        if(order.dbr != o_dbr){order.dbr = o_dbr; changed = true;}
                        if(order.drd != o_drd){order.drd = o_drd; changed = true;}
                        if(order.dti != scd.spedizione.tipoSpedizione){order.dti = scd.spedizione.tipoSpedizione; changed = true;}
                        if(order.pti != scd.consegna.tipoPorto){order.pti = scd.consegna.tipoPorto; changed = true;}

                        //possono cambiare nel 1° step del carrello
                        if(order.oty != o_oty){order.oty = o_oty; changed = true;}
                        if(order.bdi != scd.scontoBase){order.bdi = scd.scontoBase; changed = true;}
                        if(order.not != scd.note){order.not = scd.note; changed = true;}
                        if(order.coc != scd.vostroRif){order.coc = scd.vostroRif; changed = true;}

                        //può cambiare in qualunque step del carrello o nel dettaglio ordine
                        if(order.osi != scd.statoOrdine){order.osi = scd.statoOrdine; changed = true;}

                        if(changed){
                            order.mdt = now;
                            reg_orders.update(order);
                            console.log('SaveCart: Aggiornato ordine con id:', order.id, order);
                        }

                        var idOrder = order.id 
                        
                        var products = vm.shopCartData.prodotti;    
                        if( products.length > 0 ) {
                            for(var idx = 0; idx <products.length; idx++){
                                var product = products[idx];
                                var orderRow = reg_order_items.find({'id': product.id})[0];

                                if( !orderRow ) {
                                    orderRow = reg_order_items.insert( {
                                        id: "-"+reg_order_items.maxId + 1,
                                        oid : idOrder,
                                        pid: product.codiceProd,   
                                        spi: product.codSost,              
                                        ide: product.descrizione,        
                                        uni: product.unitaMisura,
                                        qty : product.quantita,
                                        unp : product.prezzoUnitario, 
                                        ulp : product.prezzoOriginario,
                                        sta: product.statoProdotto,
                                        mdt: product.dataModifica,
                                        udt : product.dataUltimaModifica,
                                        ldi: product.codlinea,
                                        mpi: product.codmacch,
                                        mde: product.desmacch,
                                        vdt: vm.$root.validity,
                                        cd1: product.scontoCliente,
                                        cd2: product.scontoArticolo,
                                        not: product.noteRiga,
                                        qas: product.statoDisponibilità
                                    } );

                                    for(var i=0;i<vm.shopCartData.prodotti.length; i++){
                                        if(vm.shopCartData.prodotti[i].codiceProd == orderRow.pid){
                                            vm.shopCartData.prodotti[i].id = orderRow.id
                                            vm.shopCartData.prodotti[i].oid = orderRow.oid
                                        }
                                    }

                                    console.log(fnName+' - Aggiunto il prodotto con id:', orderRow.id, ", record: ", orderRow);
                                }else{
                                    //sono arrivato qui se devo aggiornare il record della riga ordine
                                    //potrei aver cambiato: 
                                    //  tipo ordine (e quindi cambiano i prezzi che salvo nella riga ordine), 
                                    //  quantità,
                                    //  note 

                                    //evito update inutili confrontando i valori
                                    var changed = false;
                                    if(orderRow.qty!=product.quantita){
                                        orderRow.qty = product.quantita
                                        changed = true
                                    }
                                    if(orderRow.unp!=product.prezzoUnitario){
                                        orderRow.unp = product.prezzoUnitario
                                        changed = true
                                    }
                                    if(orderRow.ulp!=product.prezzoOriginario){
                                        orderRow.ulp = product.prezzoOriginario
                                        changed = true
                                    }
                                    if(orderRow.not!=product.noteRiga){
                                        orderRow.not = product.noteRiga
                                        changed = true
                                    }
                                    if(changed)reg_order_items.update(orderRow);
                                }
                            } 
                            // Verifico che non ci siano dei prodotti rimossi da interfaccia carrello, nel caso li rimuovo
                            var resultTemp = reg_order_items.find({oid: idOrder });  
                    
                            if( resultTemp != null) {
                                for(var i in resultTemp)
                                {
                                    var item = resultTemp[i];
                                    var prodItem = vm.shopCartData.prodotti.find(x => x.id === item.id);
                                    if( prodItem == null) {
                                        console.log(fnName+' - rimosso prodotto con id:', item.id );
                                        reg_order_items.remove(item);
                                    }
                                }
                            }
                        } else {
                            console.log("Non ci sono prodotti nel carrello", vm.shopCartData.prodotti);
                        }
                    }else{
                        console.log(fnName+' - order is null - cannot add new product to order with id: ', vm.shopCartData.id)
                    }
                }
            }               
        
            //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
            vm.$root.dbRegistry.saveDatabase(function(err) {
                if (err) {
                    console.log("saveDatabase - error : " + err);
                    cb(err);
                } else {
                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                    console.log(fnName+" - saveDatabase - database aggiornato");
                    cb();
                }
            });
        },
        saveDraft() {
            var vm = this;
            var firstStateId = vm.$root.getFirstOrderStatus().id
            if( this.shopCartData != null && this.shopCartData.statoOrdine == firstStateId ) {
                this.saveCart(function(err) {
                    if (err) {
                        console.log("error : " + err);
                    }else{
                        console.log("saveDraft - ordine ", vm.shopCartData.id, " salvato");
                        eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                    } 
                });
            }else{
                eventBus.$emit('alert', {
                    message: this.$Jed.firstUpperTranslate('order has already been saved as draft'), 
                    type: "warning" 
                })
                return;
            }
        },
        deleteCart: function(id) {
            var vm = this;
            try {
                if( vm.$root.dbRegistry == null) {
                    console.log("deleteCart - dbRegistry not loaded!");
                    return false;
                }

                var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                    reg_order_items = vm.$root.dbRegistry.getCollection('orderItems'),
                    results = null;

                if( id == 0 || id == null) {
                    return false;
                }else{
                    results = reg_orders.find({
                        'id': id
                    });
                }

                if(results && results.length > 0){
                    var order = results[0];  
                   
                    //tutte le righe ordine di quell'ordine
                    var prodResults = reg_order_items.find({
                        'oid':  order.id 
                    })
                    
                    //prima rimuovo le righe ordine associate a quell'ordine
                    if( prodResults != null && prodResults.length > 0) {
                        for(var i in prodResults) {
                            var orderRow = prodResults[i];
                            var rec = reg_order_items.find({'id': orderRow.id})[0]
                            reg_order_items.remove(rec)
                        }
                    }
                    //poi rimuovo gli ordini
                    var reco = reg_orders.find({'id': order.id})[0]
                    reg_orders.remove(reco)

                    //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                    vm.$root.dbRegistry.saveDatabase(function(err) {
                        if (err) {
                            console.log("saveDatabase - error : " + err);
                        } else {
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                            console.log("deleteCart - saveDatabase - database aggiornato");
                            eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                        }
                    });
                    
                } else {
                    console.log('ordine non trovato - id: ',  order.id);
                }
            } catch (error) {
                console.log(error);    
            }
        },
        getCart: async function(id) {
            var vm = this;
            try {
                var reg_orders, reg_order_items, reg_clients, reg_addresses, reg_provinces, results = null;
               if( vm.$root.dbRegistry == null) {
                    console.log("getCart - dbRegistry not loaded!");
                    return;
                }
                reg_orders = vm.$root.dbRegistry.getCollection('orders');
                reg_order_items = vm.$root.dbRegistry.getCollection('orderItems');                

                if(id){
                    results = reg_orders.find({
                        'id': id,
                    });
                }

                if(results && results.length > 0){
                    var order = results[0];  

                    if(this.$root.preferences.useOffline){
                        reg_clients = vm.$root.dbRegistry.getCollection('clients');
                        reg_addresses = vm.$root.dbServRegistry.getCollection('addresses')
                        reg_provinces = vm.$root.dbServRegistry.getCollection('provinces')
                    }else{
                        reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
                        reg_addresses = vm.$root.dbRegistry.getCollection('addresses')
                        reg_provinces = await vm.$root.fetchRegistryData("province", "GetProvinces", "collection")
                    }
                    var clientsRes = null;
                    if( order.coi != null)
                        clientsRes = reg_clients.findOne({  'id': order.coi  });

                    if(order.uid){
                        var reg_users = this.$root.dbRegistry.getCollection('users');
                        var userObj = reg_users.find({
                            'id': order.uid
                        })[0]
                    }
                    if( reg_addresses != null) {
                        //cerco l'indirizzo del cliente
                        var listAddress = reg_addresses.find({'cid': order.coi }),
                            main_address = null,
                            main_provName = null;
                        if ( listAddress && listAddress.length > 0) {
                            for(var i= 0; i<listAddress.length; i++){
                                if(listAddress[i].maa){ //se è l'indirizzo principale
                                    main_address = listAddress[i]
                                    main_provName = main_address.pid ? reg_provinces.find({id: main_address.pid}) ? reg_provinces.find({id: main_address.pid})[0] ? reg_provinces.find({id: main_address.pid})[0].pro : '' : '' : ''
                                }
                            }
                        }
                    }

                    var shopCartObj = new ShopCartData(vm);
                    shopCartObj.id = order.id; 
                    shopCartObj.$loki = order.$loki;
                    shopCartObj.tipoOrdine = order.oty != null ? order.oty : 'Standard';
                    shopCartObj.statoOrdine = order.osi;
                    shopCartObj.clientId = order.coi ;
                    shopCartObj.valutaOrdine = order.cid;
                    shopCartObj.userId = order.uid;
                    shopCartObj.note = order.not;
                    shopCartObj.vostroRif = order.coc;
                    
                    shopCartObj.richiedente.nomecognome = userObj.userFullname
                    shopCartObj.richiedente.id = userObj.id
                    shopCartObj.richiedente.mail = userObj.email
                    shopCartObj.richiedente.telefono = userObj.phone
                    shopCartObj.richiedente.fax = userObj.fax

                    shopCartObj.altrorichiedente.nomecognome = userObj.userFullname
                    shopCartObj.altrorichiedente.id = userObj.id
                    shopCartObj.altrorichiedente.mail = userObj.email
                    shopCartObj.altrorichiedente.telefono = userObj.phone
                    shopCartObj.altrorichiedente.fax = userObj.fax

                    shopCartObj.language = order.lid;
                    shopCartObj.scontoBase = order.bdi;
                    shopCartObj.dataOrdine = order.ord;
                    
                    shopCartObj.anagraficaCliente.ragioneSociale = clientsRes != null ? clientsRes.con : "";
                    shopCartObj.anagraficaCliente.codiceFiscale = clientsRes != null ? clientsRes.cfc : "";
                    shopCartObj.anagraficaCliente.partitaIva = clientsRes != null ? clientsRes.piva : "";
                    shopCartObj.anagraficaCliente.indirizzo = main_address ? main_address.add: "";
                    shopCartObj.anagraficaCliente.idIndirizzo = main_address ? main_address.id: "";
                    shopCartObj.anagraficaCliente.cap = main_address ? main_address.cap: "";
                    shopCartObj.anagraficaCliente.localita = main_address ? main_address.loc: "";
                    shopCartObj.anagraficaCliente.regione = main_address ? main_address.reg: "";
                    shopCartObj.anagraficaCliente.provincia = main_provName;
                    shopCartObj.anagraficaCliente.nazione = main_address ? main_address.nat: "";
                    shopCartObj.anagraficaCliente.telefono = main_address ? main_address.tel: "";
                    shopCartObj.anagraficaCliente.fax = main_address ? main_address.fax: "";

                    shopCartObj.consegna.tipoPorto = order.pti;
                    shopCartObj.consegna.idIndirizzo = order.aid;
                    shopCartObj.consegna.indirizzo = order.add;
                    shopCartObj.consegna.cap = order.cap;
                    shopCartObj.consegna.localita = order.loc;
                    shopCartObj.consegna.regione = order.reg;
                    shopCartObj.consegna.provincia = order.pro;
                    shopCartObj.consegna.nazione = order.nat;
                    shopCartObj.consegna.consegnaRichiesta = order.drd;

                    if(vm.$Behaviors.shopCart2Alternate){
                        shopCartObj.altroindirizzoconsegna.idIndirizzo = order.aid;
                        shopCartObj.altroindirizzoconsegna.indirizzo = order.add;
                        shopCartObj.altroindirizzoconsegna.cap = order.cap;
                        shopCartObj.altroindirizzoconsegna.localita = order.loc;
                        shopCartObj.altroindirizzoconsegna.regione = order.reg;
                        shopCartObj.altroindirizzoconsegna.provincia = order.pro;
                        shopCartObj.altroindirizzoconsegna.nazione = order.nat;
                    }

                    shopCartObj.spedizione.tipoSpedizione = order.dti;
                    shopCartObj.spedizione.accorpaSpedizione = order.dbr;
                    
                    shopCartObj.dataOrdine = order.ord;
                    shopCartObj.dataModifica = order.mdt;

                    var prodResults = reg_order_items.find({
                        'oid':  order.id 
                    })

                    if( prodResults != null && prodResults.length > 0) {
                        var productArray = []
                        for(var i in prodResults) {
                            productArray.push(prodResults[i].pid)
                        }
        
                        shopCartObj.prodotti = [];

                        await this.$root
                            .microservice({
                                role: "catalog",
                                cmd: "SearchByIds",
                                params: {
                                    sids: productArray,
                                    labels: ['des'],
                                    prod_info: ['mqt','pib','uni'],
                                    saleability: true
                                }
                            })
                            .then(
                                response => {
                                    var res = response.body;
                                    try {
                                        res = JSON.parse(response.body);
                                    } catch (err) {}

                                    for (let i = 0; i < res.answer.length; i++) {
                                        for (let j = 0; j < prodResults.length; j++) {
                                            if(prodResults[j].pid == res.answer[i].sid){
                                                var orderRow = {...prodResults[j], ...res.answer[i]}; //merge dei due oggetti, prevale il secondo
                                                var orderItem = new OrderRowData(null);
                                                orderItem.id = orderRow.id;
                                                orderItem.idOrder = orderRow.oid;
                                                orderItem.codiceProd = orderRow.pid;           
                                                orderItem.codSost = orderRow.spi;   
                                                orderItem.descrizione = orderRow.ide;         
                                                orderItem.unitaMisura = orderRow.uni ? orderRow.uni : prodResults[j].uni ? prodResults[j].uni : "NR"; 
                                                orderItem.quantita = orderRow.qty;
                                                orderItem.mqt = orderRow.mqt;
                                                orderItem.mqd = orderRow.mqd;
                                                orderItem.pib = orderRow.pib;
                                                orderItem.prezzoUnitario = orderRow.unp != null ? orderRow.unp : 0; 
                                                orderItem.prezzoOriginario = orderRow.ulp != null ? orderRow.ulp : 0; 
                                                orderItem.statoProdotto = orderRow.sta; 
                                                orderItem.dataModifica = orderRow.mdt; 
                                                orderItem.dataUltimaModifica = orderRow.udt
                                                orderItem.codlinea = orderRow.ldi
                                                orderItem.codmacch = orderRow.mpi
                                                orderItem.desmacch = orderRow.mde  
                                                orderItem.scontoArticolo = orderRow.cd2
                                                orderItem.scontoCliente = orderRow.cd1
                                                orderItem.noteRiga = orderRow.not
                                                orderItem.statoDisponibilità = orderRow.qas
                                                
                    
                                                shopCartObj.prodotti.push(orderItem);
                                            }
                                        }
                                    }
                                    vm.shopCartData = Object.assign({},shopCartObj);
                                },
                                err => {
                                    this.ready = true;
                                    //vedi gestione errore in main.js > microservice
                                }
                            )
                            .catch(err => {
                                console.log(err);
                                var msg = err && err.body && err.body.error ? err.body.error : ''
                                eventBus.$emit('alert', {
                                    message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByIds - " + msg +'</h5>',
                                    type: "error",
                                    action: ''
                                })
                            })
                    }else{
                        //assegno comunque l'oggetto ordine al carrello
                        vm.shopCartData = Object.assign({},shopCartObj);
                    }
                }else{
                    console.log('getCart - carrello vuoto ');
                }
            } catch (error) {
                console.log(error);   
            }
        },
        getTempReferenceId() {
            try {
                //per assicurarsi che l'id sia unico usiamo i millisecondi
                //a partire da destra 9 cifre
                var millis = Date.now(),
                    smillis = millis.toString(),
                    sliced = smillis.slice(-9)
                    return '-' + sliced
            } catch (error) {
                console.log(error);
                eventBus.$emit("alert", {type: "warning", message: error});
            }
        },
        getOrders: function() {
            var vm = this;
            var ordersList  = [];
            try  {
                var reg_orders, reg_order_items, reg_orderStatus, reg_users;

                if( vm.$root.dbRegistry == null) {
                    console.log("getOrders - dbRegistry not loaded!");
                    return;
                }

                if(this.$root.preferences.useOffline){
                    if(vm.$root.dbServRegistry == null ) {
                        console.log("getOrders - dbServRegistry not loaded!");
                        return;
                    }else{
                        reg_orderStatus = vm.$root.dbServRegistry.getCollection('orderStatuses');
                    }   
                }else{
                    reg_orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses');
                }

                reg_orders = vm.$root.dbRegistry.getCollection('orders');
                var orders = reg_orders.chain().data();
                if( orders != null && orders.length > 0) {

                    reg_order_items =  vm.$root.dbRegistry.getCollection('orderItems');
                    reg_users = vm.$root.dbRegistry.getCollection('users');                  
                    
                    var current_lang = vm.$root.token.siglaLingua;

                    for(var i in orders) {
                        var order = orders[i];
                        var orderStatusStr = '';
                        var userStr = null;

                        var orderItemsRes = reg_order_items.find({  'oid': order.id  });
                        var totaleOrdine = 0;
                        if( orderItemsRes != null && orderItemsRes.length > 0) {
                            
                            for(var i in orderItemsRes) {
                                var orderRow = orderItemsRes[i];
                                totaleOrdine += (orderRow.unp != null ?  orderRow.qty * orderRow.unp : 0); 
                            }
                        }
                        if(reg_orderStatus){
                            var orderStatus = reg_orderStatus.findOne({  'id': order.osi  });
                            if(orderStatus != null) {
                                // se "via" false, non aggiungo il record a quelli da visualizzare
                                if( orderStatus.via != null && orderStatus.via == false)
                                    continue;

                                orderStatusStr  = orderStatus.des[current_lang];
                                if( orderStatusStr == null ) orderStatusStr = orderStatus.des[vm.$root.token.defaultLang];
                            }

                            var userRes = reg_users.findOne({  'id': order.uid  });
                            
                            if( userRes != null) {
                                userStr  = userRes.user;
                            }

                            ordersList.push({
                                lokiId:  order.$loki,
                                ordId:  order.id,
                                tipoOrdine:   order.oty != null ? order.oty : 'Standard',
                                orderStatus: orderStatus,
                                statoOrdine: orderStatusStr,
                                clientId:  order.coi,
                                numOrdineCli: order.coc,
                                valutaOrdine:  order.cid,
                                userId:  userStr != null ? userStr : order.uid,
                                language:  order.lid,
                                scontoBase:  order.bdi,
                                dataOrdine:  order.ord,
                                consegnaRichiesta: order.drd,
                                totaleOrdine: totaleOrdine.toFixed(2),
                                dataConferma: order.ocd
                            });
                        }else{
                            console.log("dbServRegistry - Collection orderStatus is null")
                            return
                        }
                    }
                }
            } catch (error) {
                console.log(error);    
            }
            return ordersList;
        },
        getOrderDetail: async function(id) {
            var vm = this,
                orderObj  = {},
                reg_orders, reg_clients, reg_users, reg_order_items, reg_addresses, reg_orderStatus, reg_portTypes, reg_shippingTypes;

            if( vm.$root.dbRegistry == null) {
                console.log("getOrderDetail - dbRegistry not loaded!");
                return;
            }
            reg_orders = vm.$root.dbRegistry.getCollection('orders')
            reg_users = vm.$root.dbRegistry.getCollection('users')
            reg_order_items =  vm.$root.dbRegistry.getCollection('orderItems')
            reg_addresses =  vm.$root.dbRegistry.getCollection('addresses')

            if(this.$root.preferences.useOffline){
                if(vm.$root.dbServRegistry == null ) {
                    console.log("getOrders - dbServRegistry not loaded!");
                    return;
                }
                reg_orderStatus = vm.$root.dbServRegistry.getCollection('orderStatuses')
                reg_portTypes =  vm.$root.dbServRegistry.getCollection('ports')
                reg_shippingTypes =  vm.$root.dbServRegistry.getCollection('shippingTypes')

                reg_clients = vm.$root.dbRegistry.getCollection('clients')
            }else{
                reg_orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses')
                reg_portTypes =  vm.$root.dbRegistry.getCollection('ports')
                reg_shippingTypes =  vm.$root.dbRegistry.getCollection('shippingTypes')
                
                reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
            }

            try  {
                var current_lang = vm.$root.token.siglaLingua;

                // 1) Recupero l'ordine
                var order = null;
                order = reg_orders.findOne({ 'id': id });
                if( order != null) {
                    var orderStatusStr = '', clientStr = '', userStr = '', portStr = '', portTyp, shippingStr = '', orderItems = [];

                    // 2) Lo stato dell'ordine
                    var orderStatus = reg_orderStatus.findOne({ 'id': order.osi });
                    if(orderStatus != null) {
                        orderStatusStr  = orderStatus.des[current_lang] ? orderStatus.des[current_lang] : orderStatus.des[vm.$root.token.defaultLang];
                    }

                    // 3) Il cliente dell'ordine
                    var clientsRes = reg_clients.findOne({ 'id': order.coi });
                    if(clientsRes != null) {
                        clientStr  = clientsRes.con;
                    }

                    // 4) L'utente dell'ordine 
                    var userRes = reg_users.findOne({ 'id': parseInt(order.uid) });
                    if( userRes != null) {
                        userStr  = userRes.user;
                    }

                    // 5) Il porto
                    var portRes = reg_portTypes.findOne({ 'id': order.pti });
                    if(portRes != null) {
                        portStr = portRes.des[current_lang] ? portRes.des[current_lang] : portRes.des[vm.$root.token.defaultLang]
                        portTyp = portRes.fre
                    }

                    // 6) La spedizione
                    var shippingRes = reg_shippingTypes.findOne({ 'id': order.dti });
                    if(shippingRes != null) {
                        shippingStr  = shippingRes.des[current_lang] ? shippingRes.des[current_lang] : shippingRes.des[vm.$root.token.defaultLang];
                    }

                    // 7) Le righe ordine e l'importo totale dell'ordine
                    var orderItemsRes = reg_order_items.find({ 'oid': order.id }),
                        importoTot = 0;
                    if( orderItemsRes != null && orderItemsRes.length > 0) {
                        for(var i in orderItemsRes) {
                            var orderRow = orderItemsRes[i];
                            importoTot += orderRow.unp * orderRow.qty; 
                            orderItems.push(orderRow);
                        }
                    }
                    
                    // 8) Il nome del destinatario 
                    var addressRec = reg_addresses.find({ 'id': order.aid }),
                        destinatarioStr = addressRec.length>0 ? addressRec[0].con : '';

                    orderObj = {
                        lokiId:  order.$loki,
                        ordId:  order.id,
                        tipoOrdine: order.oty != null ? order.oty : 'Standard',
                        statoOrdine: orderStatusStr,
                        orderStatus: orderStatus,
                        clientId: clientStr,
                        numOrdineCli: order.coc,
                        valutaOrdine:  order.cid,
                        userId:  userStr,
                        language:  order.lid,
                        scontoBase:  order.bdi,
                        dataOrdine:  new Date(order.ord).toLocaleString(),
                        dataConsRich: order.drd ? new Date(order.drd).toLocaleString(): null,
                        totaleOrdine: importoTot.toFixed(2),
                        indirizzo: order.add,
                        cap: order.cap,
                        localita: order.loc,
                        provincia: order.pro,
                        regione: order.reg,
                        nazione: order.nat,
                        note: order.not,
                        noteGestore: order.cno,
                        tipoSpedizione: shippingStr,
                        tipoPort: portStr,
                        tipoPortFre: portTyp,
                        orderItems: orderItems,
                        destinatario: destinatarioStr,
                        refObj: order
                    };
                }
            } catch (error) {
                console.log(error);   
            }
            return orderObj;
        },
        getFirstOrderStatus: function(){
            var vm = this,
                reg_orderStatus, reg_orderStatusChanges, styp = '';
            try  {
                if(this.$root.preferences.useOffline){
                    if( vm.$root.dbServRegistry == null) {
                        console.log("getFirstOrderStatus - dbServRegistry not loaded!");
                        return;
                    }
                    reg_orderStatus = vm.$root.dbServRegistry.getCollection('orderStatuses')
                    reg_orderStatusChanges = vm.$root.dbServRegistry.getCollection('orderStatusChanges')
                }else{
                    reg_orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses')
                    reg_orderStatusChanges = vm.$root.dbRegistry.getCollection('orderStatusChanges')
                }
                
                if(vm.$root.token.categoriaCliente == 'Cliente distributore'){
                    styp = 'Dist-Riv'
                }else{
                    styp = 'Prod-Conc' 
                }

                var states = reg_orderStatus.chain().find({typ: styp}).simplesort('id').data()
                var transitions = reg_orderStatusChanges.find({'fsi': states[0].id  }); //prendo i passaggi di stato che hanno "from" pari al primo stato ordine 
                return {id: states[0].id, to: transitions[0].tsi}; //ritorno l'id del primo stato e l'id del suo stato di arrivo

            }catch(e){
                console.log('Stati Ordine: ')
                console.log(e)
            }
        },
        loadItemPriceAndTotalCalc(data) {
            try {
                data.prezzoOriginario = data.refObj.origin ? data.refObj.origin : 0 //prezzo originario (senza alcun sconto applicato)
                data.prezzoUnitario = data.refObj.pri ? data.refObj.pri : 0; //prezzo scontato sia in base al tipo ordine di default ('Standard') sia in base al profilo sconti del cliente
                
                data.discount = data.refObj.discount;
                data.prezzoTotale = data.prezzoUnitario * data.qty;
                data.statoProdotto =  data.prezzoUnitario == 0 ?  'Da quotare' : 'In ordine';

                data.codlinea = data.refObj.f_fid
                data.codmacch = data.refObj.f_sid
                data.desmacch = data.refObj.f_des

                data.scontoCliente = data.refObj.cd1 ? data.refObj.cd1 : null
                data.scontoArticolo = data.refObj.cd2 ? data.refObj.cd2 : null
                return true;                
            } catch (error) {
                console.log(error);
            }
            return false;
        },
        addProductToCart: function(data) { /* modifica la quantità del prodotto in carrello  */
            console.log(this.shopCartData.prodotti)
            console.log('in addProductToCart', data)
            var item = this.shopCartData ? this.shopCartData.prodotti.find( v => {
                return v['codiceProd'] === data.cod || v['codiceProd'] === data.spi
            }) : null;
            if( this.loadItemPriceAndTotalCalc(data) ) {
                var product = new OrderRowData(data)
                var cod = product.codiceProd
                //il prodotto non è ancora nel carrello
                if( item == null && this.shopCartData) {
                    this.shopCartData.prodotti.push(product);  
                    this.$root.simpleNotification("info", {
                        title: "", 
                        message: this.$Jed.firstUpperTranslate("prodotto %1$s aggiunto al carrello", null, {key: null, string: [cod +' - '+ product.descrizione]}, null) 
                    });
                    return product.quantita;
                } else { //sto aggiungendo pezzi a un prodotto già in carrello
                    var diff = product.mqd ? (product.quantita - item.quantita).toFixed(1) : (product.quantita - item.quantita)
                    if(diff!=0){
                        item.quantita = product.quantita;
                        var msg;
                        if(diff == 1 || diff == 0.1){
                            diff = Number(diff).toLocaleString()
                            msg = this.$Jed.firstUpperTranslate("aggiunto %1$s %3$s al prodotto %2$s", null, {key: null, string: [diff, cod +' - '+ product.descrizione, this.$Jed.translate(product.unitaMisura)]}, null) 
                        }else if(diff == -1 || diff == -0.1){
                            diff = Math.abs(diff)
                            diff = Number(diff).toLocaleString()
                            msg = this.$Jed.firstUpperTranslate("rimosso %1$s %3$s del prodotto %2$s", null, {key: null, string: [diff, cod +' - '+ product.descrizione, this.$Jed.translate(product.unitaMisura)]}, null) 
                        }else if(diff<0){
                            diff = Math.abs(diff)
                            diff = Number(diff).toLocaleString()
                            msg = this.$Jed.firstUpperTranslate("rimossi %1$s %3$s del prodotto %2$s", null, {key: null, string: [diff, cod +' - '+ product.descrizione, this.$Jed.translate(product.unitaMisura)]}, null) 
                        }else if(diff > 0.1){
                            diff = Number(diff).toLocaleString()
                            msg = this.$Jed.firstUpperTranslate("aggiunti %1$s %3$s al prodotto %2$s", null, {key: null, string: [diff, cod +' - '+ product.descrizione, this.$Jed.translate(product.unitaMisura)]}, null) 
                        }
                        this.$root.simpleNotification("info", {
                            title: "", 
                            message: msg
                        });
                        return item.quantita;
                    }
                }
            }     
            return 0;
        },
        getClientDiscounts: async function(clientId) {
            var vm = this,
                result = [],
                reg_clients;
            try {
                if( clientId == null || clientId == 0){
                    return result;
                }
                if( vm.$root.dbRegistry == null) {
                    console.log("getClientDiscounts - dbRegistry not loaded!");
                    return;
                }
                if(this.$root.preferences.useOffline){
                    reg_clients = vm.$root.dbRegistry.getCollection('clients');
                }else{
                    reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
                }
              
                var clientRes = reg_clients.findOne({  'id':clientId  });
                if( clientRes != null) {
                    if( clientRes.bdd != null )
                        result.push({ type: "Standard", testo: vm.$Jed.firstUpperTranslate('sconto base'), value: clientRes.bdd });
                    if(clientRes.bdu != null)
                        result.push({ type: "Urgente", testo: vm.$Jed.firstUpperTranslate('sconto urgente'), value: clientRes.bdu });
                    if(clientRes.bds != null)
                        result.push({ type: "Stock", testo: vm.$Jed.firstUpperTranslate('sconto stock'), value: clientRes.bds });
                    if(clientRes.bdm != null)
                        result.push({ type: "Manutenzioni", testo: vm.$Jed.firstUpperTranslate('sconto manutenzioni'), value: clientRes.bdm });
                }
 
            } catch (error) {
                console.log(error);
            }
            return result;
        },
        getOrderTypeOptions: async function(clientId) {            
            var vm = this;
            var result = [];
            try {
                if( clientId == null || clientId == 0)
                    return result;
                
                var reg_clients;
                if( vm.$root.dbRegistry == null) {
                    console.log("getOrderTypeOptions - dbRegistry not loaded!");
                    return;
                }
                if(this.$root.preferences.useOffline){
                    reg_clients = vm.$root.dbRegistry.getCollection('clients');
                }else{
                    reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
                }
              
                var clientRes = reg_clients.findOne({  'id':clientId  });
                
                if( clientRes != null) {
                    if( clientRes.bdd != null ){
                        result.push({ type: 'Standard', value: clientRes.bdd });
                    }else{
                        //Il tipo ordine 'Standard' c'è sempre indipendentemente dallo sconto (e indipendentemente dal cliente)
                        result.push({ type: 'Standard', value: 0 });
                    }
                    if(clientRes.bdu != null){
                        result.push({ type: 'Urgente', value: clientRes.bdu  });
                    }else{
                        //TM: il tipo ordine urgente deve esserci anche senza lo sconto base urgente. Come faccio a sapere che è tM?
                        //In base al parametro "useDiscountCategories" che trovo nel token
                        if(vm.$Configs.useDiscountCategories){ 
                            result.push({ type: 'Urgente', value: null  });
                        }
                    }
                    if(clientRes.bds != null)
                        result.push({ type: 'Stock', value: clientRes.bds  });
                    if(clientRes.bdm != null){
                        result.push({ type: 'service', value: clientRes.bdm  }); //sconto manutenzioni
                    }
                }
            } catch (error) {
                console.log(error);
            }
            return result;
        },
        orderProgress: function(id) {
            var vm = this;
            try  {
                var reg_orders, reg_order_items, reg_orderStatus, reg_orderStatusChange;
                if( vm.$root.dbRegistry == null) {
                    console.log("orderProgress - dbRegistry not loaded!");
                    return;
                }
                if(this.$root.preferences.useOffline){
                    if( vm.$root.dbServRegistry == null) {
                        console.log("orderProgress - dbServRegistry not loaded!");
                        return;
                    }
                    reg_orderStatusChange = vm.$root.dbServRegistry.getCollection('orderStatusChanges')
                    reg_orderStatus = vm.$root.dbServRegistry.getCollection('orderStatuses')
                }else{
                    reg_orderStatusChange = vm.$root.dbRegistry.getCollection('orderStatusChanges')
                    reg_orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses')
                }
                reg_orders = vm.$root.dbRegistry.getCollection('orders')
                reg_order_items =  vm.$root.dbRegistry.getCollection('orderItems')

                var order = reg_orders.findOne({'id': id});
                if( order != null) {
                    var fromStatusChanges = reg_orderStatusChange.find({  'fsi': order.osi  }); //prendo tutti i passaggi di stato che hanno "from" pari allo stato ordine attuale

                    if( fromStatusChanges == null || fromStatusChanges.length == 0 ) {
                        eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate("there is no valid status change for the order current state")});
                        return;
                    }
                    var toStatusChanges = [];
                    toStatusChanges = Array.from(fromStatusChanges, x => x.tsi); //prendo il "to" dei passaggi di stato filtrati per "from" ovvero in quali stati possono andare

                    var orderStatus = reg_orderStatus.chain().find({'id': {'$in': toStatusChanges}}).simplesort("seq").data(); //prendo gli stati in cui si può andare
                    var fromStateDes = reg_orderStatus.find({'id': order.osi})[0].des[vm.$root.token.siglaLingua];

                    if( orderStatus != null ) {
                        var orderItemsRes = reg_order_items.find({ 'oid': order.id }); //prendo le righe ordine dell'ordine attuale

                        if( orderItemsRes != null && orderItemsRes.length > 0 ){
                            var check1stChoice = true;

                            for (var j in orderStatus) {
                                var oStatus = orderStatus[j];

                                var isPriced = true;

                                // verifico se tutti i prezzi sono valorizzati e passo allo stato successivo
                                if( check1stChoice ) {
                                    for(var i in orderItemsRes) {
                                        var orderRow = orderItemsRes[i];
                                        if(orderRow.unp == 0)
                                            isPriced = false;
                                    }
                                }
                                if( !check1stChoice || !oStatus.quo || ( !isPriced && oStatus.quo )) {
                                    return { from: order.osi, fromDes: fromStateDes,  to: oStatus.id, toDes: oStatus.des[vm.$root.token.siglaLingua], toMod: oStatus.mod}
                                }

                                check1stChoice = false;
                            }
                        }
                    }

                }
            } catch (error) {
                console.log(error);    
            }
        },
        updateAvailability: function(){
            var vm = this;
            if(this.shopCartData.prodotti.length>0){
                console.log('calling update availability...')
                var syncBefore = new Promise((resolve, reject)=>{
                    if(!vm.$root.preferences.useOffline){
                        vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                        eventBus.$on('remoteSyncRegistryResolved',()=>{
                            console.log('OK sync - updateAvailabilityClick')
                            vm.isSyncing = false
                            resolve()
                        })
                    }
                })
                syncBefore.then(()=>{
                    console.log('THEN SYNC BEFORE - updateAvailabilityClick')
                    //call cmd only after resolving syncBefore promise
                    this.$root
                        .microservice({
                        role: "erpg",
                        cmd: "GetAvailability",
                        params: {
                            orderId: this.shopCartData.id
                        }
                        }).then((response) => {
                            console.log(response)
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate(); //nuova gestione sync nell'online                   
                        }, (error) => {
                            
                            //vedi gestione errore in main.js > microservice
                        })
                        .catch(err => {
                            console.log(err);
                            var msg = err && err.body && err.body.error ? err.body.error : err
                            eventBus.$emit('alert', {
                                message: "Application caught an error <br> <h5>Details: " + "erpg.GetAvailability - " + msg +'</h5>',
                                type: "error",
                                action: ''
                            })
                        })
                })
            }
        },
        async getClientAddress(origin) { /* recupero dati anagrafici del cliente da inserire nella seconda schermata del carrello */
            var vm = this,
                addrDataReady = false,
                clienDataReady = false,
                reg_addresses, reg_provinces, reg_clients,
                idC = vm.$root.token.idCliente;
            try {
                if(this.$root.preferences.useOffline){
                    if(vm.$root.dbServRegistry == null) {
                        console.log("getClientAddress - dbServRegistry not loaded!");
                        return;
                    }
                    if(vm.$root.dbRegistry == null) {
                        console.log("getClientAddress - dbRegistry not loaded!");
                        return;
                    }     
                    reg_addresses = vm.$root.dbServRegistry.getCollection('addresses')
                    reg_provinces = vm.$root.dbServRegistry.getCollection('provinces')
                    reg_clients = vm.$root.dbRegistry.getCollection('clients')
                }else{
                    if(vm.$root.dbRegistry == null) {
                        console.log("getClientAddress - dbRegistry not loaded!");
                        return;
                    } 
                    reg_addresses = vm.$root.dbRegistry.getCollection('addresses')
                    reg_provinces = await vm.$root.fetchRegistryData("province", "GetProvinces", "collection")
                    reg_clients = await vm.$root.fetchRegistryData("client", "GetClients", "collection")
                }
                
                if( reg_addresses != null) {
                    //cerco l'indirizzo del cliente
                    var listAddress = reg_addresses.find({'cid': idC }),
                        delivery_address = null,
                        delivery_provName = null,
                        main_address = null,
                        main_provName = null;
                    if ( listAddress != null && listAddress.length > 0) {
                        for(var i= 0; i<listAddress.length; i++){
                            if(listAddress[i].dea){ //se è un indirizzo di consegna
                                delivery_address = listAddress[i]
                                delivery_provName = delivery_address.pid ? reg_provinces.find({id: delivery_address.pid}) ? reg_provinces.find({id: delivery_address.pid})[0] ? reg_provinces.find({id: delivery_address.pid})[0].pro : '' : '' : ''
                            }
                            if(listAddress[i].maa){ //se è l'indirizzo principale
                                main_address = listAddress[i]
                                main_provName = main_address.pid ? reg_provinces.find({id: main_address.pid}) ? reg_provinces.find({id: main_address.pid})[0] ? reg_provinces.find({id: main_address.pid})[0].pro : '' : '' : ''
                            }
                        }
                        if(this.$Behaviors.shopCart2Alternate){
                            this.shopCartData.consegna.idIndirizzo = delivery_address.id //serve perchè quando faccio l'insert in order la proprietà aid non può essere null
                            
                            this.shopCartData.consegna.indirizzo = delivery_address ? delivery_address.add: "";    
                            this.shopCartData.consegna.cap = delivery_address ? delivery_address.cap: "";    
                            this.shopCartData.consegna.localita = delivery_address ? delivery_address.loc: "";    
                            this.shopCartData.consegna.provincia = delivery_provName;
                            this.shopCartData.consegna.regione = delivery_address ? delivery_address.reg: "";    
                            this.shopCartData.consegna.nazione = delivery_address ? delivery_address.nat: "";   
                        }

                        this.shopCartData.anagraficaCliente.indirizzo = main_address ? main_address.add: "";    
                        this.shopCartData.anagraficaCliente.idIndirizzo = main_address ? main_address.id: "";  
                        this.shopCartData.anagraficaCliente.cap = main_address ? main_address.cap: "";    
                        this.shopCartData.anagraficaCliente.localita = main_address ? main_address.loc: "";    
                        this.shopCartData.anagraficaCliente.provincia = main_provName;
                        this.shopCartData.anagraficaCliente.regione = main_address ? main_address.reg: "";    
                        this.shopCartData.anagraficaCliente.nazione = main_address ? main_address.nat: "";    
                        this.shopCartData.anagraficaCliente.telefono = main_address ? main_address.tel: "";    
                        this.shopCartData.anagraficaCliente.fax = main_address ? main_address.fax: "";    
                        this.shopCartData.anagraficaCliente.mail = main_address ? main_address.mai: "";
                        addrDataReady = true;

                    }else{
                        console.log(vm.$Jed.firstUpperTranslate("unable to start cart because there is no defined address or address is incomplete for the current client") )
                        /* if(origin == 'start'){
                            vm.$root.simpleNotification("warning", {
                                title: "", 
                                message: vm.$Jed.firstUpperTranslate("unable to start cart because there is no defined address or address is incomplete for the current client") 
                            });
                        }else{
                            eventBus.$emit('alert', {
                                message: this.$Jed.firstUpperTranslate('unable to start cart because there is no defined address or address is incomplete for the current client'), 
                                type: "warning" 
                            })
                            vm.$router.go(-1) //il carrello non verrà istanziato -> non ha senso far vedere la schermata del carrello -> torno alla pagina precedente
                        } */
                    }
                }
                if( reg_clients != null) {
                    var clientsRes = reg_clients.findOne({  'id': idC  });
                    if( clientsRes != null ) {
                        this.shopCartData.anagraficaCliente.ragioneSociale = clientsRes.con != null ? clientsRes.con: "";
                        this.shopCartData.anagraficaCliente.codiceFiscale = clientsRes.cfc != null  ?  clientsRes.cfc: "";
                        this.shopCartData.anagraficaCliente.partitaIva = clientsRes.piva  != null ? clientsRes.piva: "";
                        this.shopCartData.anagraficaCliente.nomeTitolare = clientsRes.own  != null ? clientsRes.own: "";
                        clienDataReady = true;
                    }
                }
                return (addrDataReady && clienDataReady);
            } catch (error) {
                console.log(error)
                return (addrDataReady && clienDataReady);            
            }
        },

        /**
         * Operazioni su indirizzi e utenti
         */
        SaveAddress: function(data) {
            var vm = this;
            try {
                if( vm.$root.dbRegistry == null) {
                    console.log("SaveAddress - dbRegistry not loaded!");
                    return;
                }                

                var reg_addresses = vm.$root.dbRegistry.getCollection('addresses'),
                    idC = vm.$root.token.idCliente,
                    message = '';

                if( reg_addresses != null) {
                    
                    // verifico che non esista già l'indirizzo
                    var listAddress = reg_addresses.find({'$or': [{ 'id' : data.id },{  'add': data.add,  'cid': idC }] });
                    let now = new Date();

                    if ( listAddress != null && listAddress.length > 0) {
                        var address = listAddress[0];
                        address.cid = idC;
                        address.add = data.add; // indirizzo 
                        address.maa = false; // flag indirizzo principale
                        address.dea = true; // flag indirizzo consegna
                        address.cap = data.cap; // cap 
                        address.loc = data.loc; // localita
                        address.pid = data.pid; // id provincia (per gli indirizzi inseriti dall'utente non deve essere valorizzato) 
                        address.sip = data.sip;
                        address.reg = data.reg; // regione 
                        address.pro = data.pro; // provincia 
                        address.nat = data.nat.type ? data.nat.type : data.nat ? data.nat : ''; // nazione 
                        address.tel = data.tel; // telefono 
                        address.fax = data.fax; // fax 
                        address.cel = data.cel; // cellulare 
                        address.mai = data.mai; // mail 
                        address.con = data.con; // contatto (nome persona) 
                        address.sti = data.sti; // id magazzino 
                        address.cii = data.cii; // id cliente inserimento 
                        address.cld = data.cld; // giorno chiusura 
                        address.mdt = now; //data modifica 
                        reg_addresses.update(address);

                        console.log('SaveAddress - modifica indirizzo: ', address);

                        message = vm.$Jed.firstUpperTranslate("address modified")  +': '+address.add                        
                    } else {
                        var a = reg_addresses.chain()
                                    .find({cid: idC}) //indirizzo associato al cliente attuale
                                    .where(function(obj) {
                                        return obj.mac.indexOf(idC) == 0; //il codice indirizzo (mac) contiene il codice cliente (alla prima posizione)
                                    })
                                    .data();
                        var mac = idC;
                        //a è un array di indirizzi che nel codice indirizzo (mac) contengono il codice del cliente
                        if(a && a.length>0){
                            var max = 1;
                            for (let index = 0; index < a.length; index++) {
                                try{
                                    const el = a[index].mac.split("--")[1];
                                    if(el){
                                        if(Number(el) >= max) max = Number(el)+1
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                            }
                            mac = idC+"--"+max;
                        }
                         
                        var address = reg_addresses.insert( {
                            id: data.id,
                            cid: idC,
                            add: data.add, // indirizzo 
                            maa: false, // flag indirizzo principale
                            dea: true, // flag indirizzo consegna/secondario
                            mac: mac, //codice gestionale indirizzo
                            cap: data.cap, // cap 
                            loc: data.loc, // localita 
                            pid: data.pid, // id provincia (per gli indirizzi inseriti dall'utente non deve essere valorizzato)
                            sip: data.sip,
                            reg: data.reg, // regione 
                            pro: data.pro, // provincia 
                            nat: data.nat.type, // nazione 
                            tel: data.tel, // telefono 
                            fax: data.fax, // fax 
                            cel: data.cel, // cellulare 
                            mai: data.mai, // mail 
                            con: data.con, // contatto (nome persona) 
                            sti: data.sti, // id magazzino 
                            cii: data.cii, // id cliente inserimento 
                            cld: data.cld, // giorno chiusura 
                            mdt: now // data modifica 
                        });

                        console.log('SaveAddress - inserimento di un nuovo indirizzo:', address);
                        
                        message = vm.$Jed.firstUpperTranslate("new address added")
                    }

                    //alla fine delle op sul loki degli indirizzi salvo il loki db e chiedo la sync
                    vm.$root.dbRegistry.saveDatabase(function(err) {
                        if (err) {
                            console.log("saveDatabase - error : " + err);
                        }else {
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                            console.log("SaveAddress - saveDatabase - database aggiornato");
                            vm.$root.simpleNotification("success", {
                                title: "", 
                                message: message 
                            });
                        }
                    });
                }               
            } catch (error) {
                console.log(error)            
            }
        },
        DeleteAddress: function(data) {
            var vm = this;
            try {

                if( data == null)
                    return;
            
                if( vm.$root.dbRegistry == null) {
                    console.log("DeleteAddress - dbRegistry not loaded!");
                    return;
                }                

                var reg_addresses = vm.$root.dbRegistry.getCollection('addresses');

                if(reg_addresses) {
                    // verifico che esista l'indirizzo
                    var elem = reg_addresses.findOne({'$loki': data.$loki});  
                    if(elem){
                        reg_addresses.remove(elem);

                        //alla fine delle op sul loki degli indirizzi salvo il loki db e chiedo la sync
                        vm.$root.dbRegistry.saveDatabase(function(err) {
                            if (err) {
                                console.log("saveDatabase - error : " + err);
                            }else {
                                if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                console.log("DeleteAddress - saveDatabase - database aggiornato");
                                vm.$root.simpleNotification("success", {
                                    title: "", 
                                    message: vm.$Jed.firstUpperTranslate("deleted address")+': '+data.add
                                });
                            }
                        });
                    }else{
                        console.log("no address found with $loki: ", data.$loki, data)
                    } 
                }else{
                    console.log("reg_addresses is null!")
                }               
                    
            } catch (error) {
                console.log(error)            
            }
        },
        SaveUser: function(data) {
            var vm = this;
            try {
                if( vm.$root.dbRegistry == null) {
                    console.log("SaveUser - dbRegistry not loaded!");
                    return;
                }                

                var reg_users = vm.$root.dbRegistry.getCollection('users'),
                    message = '';

                if( reg_users != null) {
                    // verifico che non esista già l'utente
                    var existingUser = reg_users.find({'id' : data.id});
                    let now = new Date();

                    if ( existingUser != null && existingUser.length > 0) {
                        var user = existingUser[0];
                        user.mdt = now; //data modifica
                        user.user = data.user, 
                        user.userFullname = data.userFullname,
                        user.email = data.email,
                        user.phone = data.phone,                         
                        user.fax = data.fax 

                        reg_users.update(user);
                        console.log('SaveUser: modifica di utente con id:', user.id);
                        message = vm.$Jed.firstUpperTranslate("user modified") +': '+user.user
                    } else {                         
                        var user = reg_users.insert(data);
                        console.log('SaveUser: inserimento di un nuovo utente con id:', user.id);
                        message = vm.$Jed.firstUpperTranslate("new user added")
                    }

                    //alla fine delle op sul loki degli utenti salvo il loki db e chiedo la sync
                    vm.$root.dbRegistry.saveDatabase(function(err) {
                        if (err) {
                            console.log("saveDatabase - error : " + err);
                        }else {
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                            console.log("SaveUser - saveDatabase - database aggiornato");
                            vm.$root.simpleNotification("success", {
                                title: "", 
                                message: message 
                            });
                        }
                    });
                }               
            } catch (error) {
                console.log(error)            
            }
        },
        DeleteUser: function(data, index) {
            var vm = this;
            try {

                if( data == null)
                    return;
            
                if( vm.$root.dbRegistry == null) {
                    console.log("DeleteUser - dbRegistry not loaded!");
                    return;
                }                

                var reg_users = vm.$root.dbRegistry.getCollection('users')

                if( reg_users != null) {
                    // verifico che esista l'utente
                    var existingUser = reg_users.find({'id' : data.id});
                    if(existingUser != null){
                        reg_users.remove(existingUser);

                        //alla fine delle op sul loki degli utenti salvo il loki db e chiedo la sync
                        vm.$root.dbRegistry.saveDatabase(function(err) {
                            if (err) {
                                console.log("saveDatabase - error : " + err);
                            }else {
                                if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                console.log("DeleteUser - saveDatabase - database aggiornato");
                                vm.$root.simpleNotification("success", {
                                    title: "", 
                                    message: vm.$Jed.firstUpperTranslate("deleted user")+': '+data.user
                                });
                            }
                        });
                    }
                    //console.log(index)
                    //$("#TabellaUtenti").jqxGrid('deleterow', index);
                    //$('#TabellaUtenti').jqxGrid('refreshdata'); //aggiorno il contenuto della grid di OtherRequester
                    //$('#TabellaUtenti').jqxGrid('updatebounddata'); //aggiorno il contenuto della grid di OtherRequester
                }     
            } catch (error) {
                console.log(error)            
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/shopcart_registry_mixin.js